import { render } from "./updateEmail.vue?vue&type=template&id=b426d0be"
import script from "./updateEmail.vue?vue&type=script&lang=js"
export * from "./updateEmail.vue?vue&type=script&lang=js"

import "./updateEmail.vue?vue&type=style&index=0&id=b426d0be&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__